import React, { useCallback, useEffect } from 'react';
import { FormikProvider, useFormik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';

import { CreateUser, Button, CancelCreateModal } from '../../../components';
import { createUser, createUserAdmin } from '../../../store/users';
import { BackIcon } from '../../../assets';
import { usePreventLeave } from '../../../hooks/usePreventLeave';
import { createUserSchema } from '../../../utils';
import { USER_ROLES } from "../../../constants/constants";

import styles from './index.module.css';
import { Navigation } from '../../../utils/navigation'
import { fetchAllHealthOrganizations } from '../../../store/health_organizations';

const initialValues = {
  email: '',
  firstName: '',
  lastName: '',
  orgList: [],
};

const Create_User = ({ createUser, createUserAdmin, managedRole, title, headText,
  healthOrganizations,
  fetchAllHealthOrganizations
}) => {
  const user = useSelector((state) => state.authorization.user);
  const navigate = Navigation();
  const formik = useFormik({
    initialValues,
    validateOnMount: true,
    validationSchema: createUserSchema,
    onSubmit: (values) => {
      console.log('Create_User formik values', values);
      unblockHistory?.current && unblockHistory.current();
      
      if (
        managedRole === USER_ROLES.TC_ADMIN ||
        managedRole === USER_ROLES.HO_ADMIN || 
        managedRole === USER_ROLES.ENTERPRISE_ADMIN 
      ) {
        values.userRole = managedRole;
        createUserAdmin({ payload: values, Navigation: navigate });
      } else {
        createUser({ payload: values, Navigation: navigate });
      }
    },
  });

  useEffect(() => {
    if (user.parentOrgId && managedRole === USER_ROLES.HO_EMPLOYEE ) {
      fetchAllHealthOrganizations();
    }

    return;
  }, [fetchAllHealthOrganizations]);

  const [visibleModal, setModalVisible, unblockHistory, location] = usePreventLeave(initialValues, formik.values);

  const handleBack = useCallback(() => {
    navigate.push(navigate?.location?.state?.from);
  }, [navigate]);

  const onCancel = useCallback(() => setModalVisible(false), [setModalVisible]);

  const onLeave = useCallback(() => {
    if (unblockHistory?.current) {
      unblockHistory.current();
      navigate.push(location.location);
    }
  }, [navigate, location, unblockHistory]);

  return (
    <div className={styles.pageContent}>
      <div className={styles.header}>
        <div className={styles.backBtn} onClick={handleBack}>
          <BackIcon width='26px' height='26px' fill='#E1F4D3' />
        </div>
        <h1 className={styles.pageTitle}>{title}</h1>
      </div>
      <div>
        <h2>{headText}</h2>
        <FormikProvider value={formik}>
          <form className={styles.form} onSubmit={formik.handleSubmit}>
            <CreateUser values={formik.values} {...formik}
              healthOrganizations={healthOrganizations}
              isParentOrg={!!user.parentOrgId}
              managedRole={managedRole} />
            <div className={styles.btnPanel}>
              <div className={styles.btnControl}>
                <Button myClassName={styles.navigationBtn} onClick={handleBack}>
                  Cancel
                </Button>
              </div>
              <div className={styles.btnControl}>
                <Button disabled={!formik.isValid} type='submit'>
                  Send Invite
                </Button>
              </div>
            </div>
          </form>
        </FormikProvider>
      </div>

      <CancelCreateModal
        title={`Canceling New ${managedRole}`}
        visible={visibleModal}
        onCancel={onCancel}
        onLeave={onLeave}
      />
    </div>
  );
};

const mapStateToProps = (state) => (
  {
    healthOrganizations: state.healthOrganizations.healthOrganizations,
  });

const mapDispatchToProps = (dispatch) => bindActionCreators({
  createUser,
  createUserAdmin,
  fetchAllHealthOrganizations
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Create_User);
